@if(visibleSoloNuevo == false){
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-row">
        <div class="a-w1 a-w1-row">
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <p-select [options]="ListaTodosTipoDoc" placeholder="‎ " optionLabel="nombre"
                        formControlName="tipodocumento" optionValue="codigo" appendTo="body" styleClass="w-full md:w-56"
                        (onChange)="CambiarModo2($event)" [showClear]="true">
                    </p-select>
                    <label for="on_label">Tipo Documento</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="numerodoc" type="text" pInputText class="w-full md:w-56"
                        [maxlength]="naturalb === true? 8:11" />
                    <label for="on_label">N° Documento</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5" *ngIf="naturalb">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="nombreschofer" type="text" pInputText class="w-full md:w-56" />
                    <label for="on_label">Nombre Chofer</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5" *ngIf="!naturalb">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="razonsocial" type="text" pInputText class="w-full md:w-56" />
                    <label for="on_label">Razón Social</label>
                </p-floatlabel>
            </div>
            <div class="a-example-full-width-alterno-content-5">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <input formControlName="brevete" type="text" pInputText class="w-full md:w-56" [maxlength]="10" />
                    <label for="on_label">N° Brevete</label>
                </p-floatlabel>
            </div>
            <div style="display: flex; gap: 20px;">
                <p-button icon="pi pi-search" label="Buscar" (onClick)="buscar()"></p-button>
                <p-button icon="pi pi-plus" label="Nuevo" (onClick)="nuevo()"></p-button>
                <p-button icon="pi pi-file-excel" label="Importar" (onClick)="importExcel()"></p-button>
                <p-button icon="pi pi-file-excel" label="Exportar Formato" (onClick)="exportExcel()"></p-button>
            </div>
        </div>
    </form>
</div>
<app-datatable [metadataTable]="metadataTable" [dataTable]="dataTable" [filterGlobal]="true">
    <ng-template #addHeaderStart>
        <th class="header">
            <div class="items-header">
                <span>Acción</span>
            </div>
        </th>
    </ng-template>
    <ng-template #addBodyStart let-row="row">
        <td class="a-datatable-datos-body-accion row-space">
            <p-confirmPopup></p-confirmPopup>
            <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-info p-button-outlined"
                (onClick)="editChofer(row)" pTooltip="Editar" tooltipPosition="top"
                [disabled]="row.spcH_Activo === true ? false: true"></p-button>
            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-warn p-button-outlined"
                (onClick)="TransaccionChofer('D',row)" pTooltip="Desactivar" tooltipPosition="top"
                [disabled]="row.spcH_Activo === true ? false: true"></p-button>
            <p-button [icon]="row.spcH_Activo === true && row.spcH_Bloqueado === true ? 'pi pi-eye': 'pi pi-lock'"
                styleClass="p-button-rounded p-button-danger p-button-outlined" (onClick)="abrirObservaciones(row)"
                [pTooltip]="row.spcH_Activo === true && row.spcH_Bloqueado === true ? 'Ver Observaciones': 'Bloquear'"
                tooltipPosition="top"></p-button>
            <p-button icon="pi pi-lock-open" styleClass="p-button-rounded p-button-success p-button-outlined"
                (onClick)="desbloquear(row)" pTooltip="Desbloquear" tooltipPosition="top"
                *ngIf="row.spcH_Activo === true && row.spcH_Bloqueado === true ? true : false"></p-button>
        </td>
    </ng-template>
</app-datatable>
}
<p-dialog header="Mantenimiento Chofer" [(visible)]="visible" [style]="{width: '40vw',height: '50vh'}" appendTo="body" [closable]="false">
    <br />
    <div class="a-example-full-width-alterno-content">
        <p-toast></p-toast>
        <form [formGroup]="groupPoppup" class="a-w1" style="margin: 0;">
            <div class="a-w1-row" style="padding-top: 5px;">
                <div class="a-w2">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select [options]="ListaTodosTipoDoc" placeholder="‎ " optionLabel="nombre"
                            formControlName="tipodocumento" optionValue="codigo" appendTo="body"
                            styleClass="w-full md:w-56" (onChange)="CambiarModo($event)" [readonly]="!visiblebtn"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('tipodocumento')?.invalid && (this.groupPoppup.get('tipodocumento')?.touched)}">
                        </p-select>
                        <label for="on_label">Tipo Documento</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('tipodocumento')?.invalid && (this.groupPoppup.get('tipodocumento')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
                <div class="a-w2">
                    <p-inputgroup>
                        <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                            <input formControlName="numerodoc" type="text" pInputText class="w-full md:w-56"
                                [maxlength]="natural === true? 8:11" [readonly]="!visiblebtn"
                                [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('numerodoc')?.invalid && (this.groupPoppup.get('numerodoc')?.touched), readonly: !visiblebtn}" />
                            <label for="on_label">N° Documento</label>
                        </p-floatlabel>
                        <button type="button" pButton pRipple icon="pi pi-search" (click)="validarDocumento()"
                            styleClass="p-button-info"></button>
                    </p-inputgroup>
                    <small
                        *ngIf="this.groupPoppup.get('numerodoc')?.invalid && (this.groupPoppup.get('numerodoc')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;" *ngIf="natural">
                <div class="a-w2">
                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <input formControlName="nombreschofer" type="text" pInputText class="w-full md:w-56"
                            appendTo="body" [readonly]="!visiblebtn"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('nombreschofer')?.invalid && (this.groupPoppup.get('nombreschofer')?.touched), readonly: !visiblebtn}" />
                        <label for="on_label">Nombre Chofer</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('nombreschofer')?.invalid && (this.groupPoppup.get('nombreschofer')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
                <div class="a-w2">
                    <p-floatlabel class="w-full md:w-56 bold-floatlabel" variant="on">
                        <input formControlName="apellidochofer" type="text" pInputText class="w-full md:w-56"
                            appendTo="body" [readonly]="!visiblebtn"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('apellidochofer')?.invalid && (this.groupPoppup.get('apellidochofer')?.touched), readonly: !visiblebtn}" />
                        <label for="on_label">Apellidos</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('apellidochofer')?.invalid && (this.groupPoppup.get('apellidochofer')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;" *ngIf="!natural">
                <div class="a-w1">
                    <p-floatlabel variant="on" class="w-full md:w-56 bold-floatlabel">
                        <input formControlName="razonsocial" pInputText type="text" class="w-full"
                            [ariaDisabled]="!visiblebtn" appendTo="body" [readonly]="!visiblebtn"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('razonsocial')?.invalid && (this.groupPoppup.get('razonsocial')?.touched), readonly: !visiblebtn}" />
                        <label for="float-label">Razón Social</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('razonsocial')?.invalid && (this.groupPoppup.get('razonsocial')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
                <div class="a-w2">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <input formControlName="brevete" type="text" pInputText class="w-full md:w-56" [maxlength]="10"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppup.get('brevete')?.invalid && (this.groupPoppup.get('brevete')?.touched), readonly: !visiblebtn}" />
                        <label for="on_label">N° Brevete</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppup.get('brevete')?.invalid && (this.groupPoppup.get('brevete')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <!-- <div class="a-w1-row" style="padding-top: 20px;">
                <p-floatlabel class="w-full md:w-56" variant="on">
                    <textarea pTextarea rows="5" cols="30" formControlName="motivo" style="width: 100%;"
                        class="w-full md:w-56"></textarea>
                    <label for="on_label">Motivo</label>
                </p-floatlabel>
            </div> -->
            <!-- <div class="a-w1-row" style="padding-top: 20px;">
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <p-select [options]="listEmpresa" placeholder="‎ " optionLabel="nombre"
                            formControlName="empresa" optionValue="codigo" appendTo="body" class="w-full md:w-56">
                        </p-select>
                        <label for="on_label">Empresa</label>
                    </p-floatLabel>
                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <p-select [options]="listSucursal" placeholder="‎ " optionLabel="nombre"
                            formControlName="sucursal" optionValue="codigo" appendTo="body" class="w-full md:w-56">
                        </p-select>
                        <label for="on_label">Sucursal</label>
                    </p-floatLabel>
                </div>
            </div> -->
        </form>
    </div>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button *ngIf="visiblebtn" label="Guardar" (onClick)="TransaccionChofer('I', 0)"></p-button>
        <p-button *ngIf="!visiblebtn" label="Actualizar" (onClick)="TransaccionChofer('U', 0)"></p-button>
        <p-button label="Salir" (onClick)="salir()"></p-button>
    </div>
</p-dialog>
<p-dialog header="" [(visible)]="visibleImport" [style]="{width: '90vw',height: '90vh'}">
    <br>
    <p-toast />
    <div fxLayoutGap="20px" class="a-w1" style="display: flex; justify-content: center;">
        <input type="file" (change)="onFileChange($event)" id="fileInput" #fileInput style="display: none" />
        <p-button icon="pi pi-file-excel" label="Cargar Excel" severity="info" (onClick)="selectFile()"></p-button>
        <p-button icon="pi pi-save" label="Guardar Excel" severity="info" [disabled]="disabledSave"
            (onClick)="guardarExcel()"></p-button>
        <p-button icon="pi pi-sign-out" label="Salir" severity="info" (onClick)="salirImportar()"></p-button>
    </div>
    <div style="padding-top: 30px;">
        <app-datatable [dataTable]="dataTableImport" [metadataTable]="metadataTableImport" [scrollHeight]="'600px'">
            <ng-template #addHeaderStart>
                <th class="header">
                    <div class="items-header">
                        <span></span>
                    </div>
                </th>
            </ng-template>
            <ng-template #addBodyStart let-row="row">
                <td class="a-datatable-datos-body-accion row-space">
                    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-outlined"
                        (onClick)="deleteRow(row)" pTooltip="Eliminar" tooltipPosition="top"
                        [disabled]="row.conObservacion === true ? false: true"></p-button>
                </td>
            </ng-template>
        </app-datatable>
    </div>
</p-dialog>
<p-dialog header="" [(visible)]="visibleObsr" [style]="{width: '40vw',height: '45vh'}" appendTo="body">
    <div class="a-example-full-width-alterno-content">
        <form [formGroup]="groupPoppupObs" class="a-w1" style="margin: 0;">
            <div class="a-w1-row" style="padding-top: 5px;">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select [options]="ListaTodosTipoBlo" placeholder="‎ " optionLabel="nombre"
                            formControlName="tipobloqueo" optionValue="codigo" appendTo="body"
                            styleClass="w-full md:w-56" [readonly]="verObsr"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppupObs.get('tipobloqueo')?.invalid && (this.groupPoppupObs.get('tipobloqueo')?.touched)}">
                        </p-select>
                        <label for="on_label">Tipo Bloqueo</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppupObs.get('tipobloqueo')?.invalid && (this.groupPoppupObs.get('tipobloqueo')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
            <div class="a-w1-row" style="padding-top: 20px;">
                <div class="a-w1">
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <textarea pTextarea rows="5" cols="30" formControlName="observaciones" style="width: 100%;"
                            class="w-full md:w-56" [readOnly]="verObsr"
                            [ngClass]="{'ng-invalid ng-dirty': this.groupPoppupObs.get('observaciones')?.invalid && (this.groupPoppupObs.get('observaciones')?.touched), readonly: verObsr}"></textarea>
                        <label for="on_label">Observaciones</label>
                    </p-floatlabel>
                    <small
                        *ngIf="this.groupPoppupObs.get('observaciones')?.invalid && (this.groupPoppupObs.get('observaciones')?.touched)"
                        class="text-red-600 text-xs">
                        Este campo es obligatorio
                    </small>
                </div>
            </div>
        </form>
    </div>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 20px;">
        <p-button label="Guardar" *ngIf="verObsr===true?false:true" (onClick)="TransaccionChofer('B', 0)"></p-button>
        <p-button label="Salir" *ngIf="verObsr===true?false:true" (onClick)="salirBloqueo()"></p-button>
    </div>
</p-dialog>